@if (factors().length) {
  <mat-chip-set>
    @for (factor of factors(); track factor) {
      <mat-chip [disableRipple]="true">
        @if(factor.icon) {
          <mat-icon matChipAvatar>{{ factor.icon }}</mat-icon>
        }
        {{ factor.label  | translate: locale.language }}
      </mat-chip>
    }
  </mat-chip-set>
} @else {
  <span class="mfa-muted">{{ 'Reports.MfaAdoption.Factor.None' | translate: locale.language }}</span>
}
